import { z } from 'zod';
export const toolFindFieldsArgsSchema = z.object({
    type: z.literal('find_fields'),
    exploreName: z.string().describe('Name of the selected explore'),
});
export const toolFindFieldsArgsSchemaTransformed = toolFindFieldsArgsSchema;
//# sourceMappingURL=toolFindFieldsArgs.js.map